<template>

  <!-- start::component container -->
  <div id="page-product-edit">

    <!-- start::top row -->
    <vs-row class="mb-5">

      <!-- start::column title and breacrumbs -->
      <vs-col vs-type="flex" vs-align="center" vs-w="8">
        <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
          <h2 class="mb-1">
            {{ pageTitle }}
          </h2>
        </div>
        <div class="vx-breadcrumb ml-4 md:block hidden">
          <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
              <a href="/" class="router-link-active">
                <span class="feather-icon select-none relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-home h-5 w-5 mb-1 stroke-current text-primary">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </span>
              </a>
              <span class="breadcrumb-separator mx-2">
                <span class="feather-icon select-none relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevrons-right w-4 h-4">
                    <polyline points="13 17 18 12 13 7"></polyline>
                    <polyline points="6 17 11 12 6 7"></polyline>
                  </svg>
                </span>
              </span>
            </li>
            <li class="inline-flex items-center">
              <a href="/products/list" class="">Πηγές</a>
              <span class="breadcrumb-separator mx-2 flex items-start">
                <span class="feather-icon select-none relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-chevrons-right w-4 h-4">
                    <polyline points="13 17 18 12 13 7"></polyline>
                    <polyline points="6 17 11 12 6 7"></polyline>
                  </svg>
                </span>
              </span>
            </li>
            <li class="inline-flex">
              <span class="cursor-default" v-if="!item.id">Προσθήκη νέας πηγής</span>
              <span class="cursor-default" v-if="item.id">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </vs-col>
      <!-- end::column title and breacrumbs -->

      <!-- start::column return back -->
      <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="4">
        <vs-button @click="$router.push('/eshops')" color="primary" type="filled" icon="undo"
          class="ml-1 mb-2">
          Επιστροφή
        </vs-button>
      </vs-col>
      <!-- end::column return back -->

    </vs-row>
    <!-- end::top row -->

    <!-- start::card -->
    <div class="vx-card p-6">

      <!-- Content Row -->
      <div class="vx-row">
        <div class="vx-col md:w-3/3 w-full">

          <!-- start::form -->
          <validation-observer ref="eshopObserver" v-slot="{invalid}">
              <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full">
                  <validation-provider rules="required" v-slot="{errors}">
                    <vs-input class="w-full mt-4" label="Όνομα*" name="name" v-model="name" />
                    <div class="text-right text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <validation-provider rules="required" v-slot="{errors}">
                    <vs-input class="w-full mt-4" label="Σύνδεσμος*" name="url" v-model="url" />
                    <div class="text-right text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <br>
                  <span>Ενεργή</span>
                  <vs-switch v-model="checked" />
                </div>
              </div>
          </validation-observer>
          <!-- end::form -->
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
<!--            <vs-button class="ml-auto mt-2" type="border" color="warning" @click="reset_data">Καθαρισμός</vs-button>-->
            <vs-button class="ml-4 mt-2" @click.prevent="addRecord">Αποθήκευση</vs-button>
          </div>
        </div>
      </div>

    </div>
    <!-- end::card -->

  </div>
  <!-- end::component container -->

</template>

<script>
import Vue from "vue";
import vSelect from 'vue-select'
import VueRepeater from 'vue-repeater'

// Validation
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required} from 'vee-validate/dist/rules'
import VueCurrencyInput from 'vue-currency-input'
const pluginOptions = {
  /* see config reference */
  globalOptions: {currency: 'EUR'}
}
extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})

export default {
  components: {
    vSelect,
    'vue-repeater': VueRepeater,
    ValidationObserver,
    ValidationProvider,
  },
  name: 'eshop-edit',
  data() {
    return {
      initiated: false,
    }
  },
  computed: {
    // Page title
    pageTitle() {
      return this.$store.getters.getProductPageCaption
    },
    // The product
    item() {
      return this.$store.getters.getShop
    },
    // Getter and setter for name
    name: {
      get() {
        return this.item.name
      },
      set(value) {
        this.$store.dispatch('setShopName', value)
      },
    },
    // Getter and setter for url
    url: {
      get() {
        return this.item.url
      },
      set(value) {
        this.$store.dispatch('setShopUrl', value)
      },
    },
    // Getter and setter for live_status
    live_status: {
      get() {
        return this.item.live_status
      },
      set(value) {
        this.$store.dispatch('setShopLiveStatus', value)
      },
    },
    // Getter and setter for checked
    checked: {
      get() {
        return this.item.checked
      },
      set(value) {
        this.$store.dispatch('setShopChecked', value)
      },
    }
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    removeElement: function (index) {
      let vm = this
      this.links.splice(index, 1)
    },
    // Reset new product form
    reset_data() {
      const eshop = {
        name: '',
        live_status: false,
        url: '',
        is_crawled: false,
        checked: false,
      }
      this.$store.dispatch('setShop', eshop)
    },

    // This method must be async because:
    // 1. The add button is outside the form so we must validate it in code.
    // 2. Validate method of validation observer is a Promise
    async addRecord() {
      // Validate the eshop
      const valid = await this.$refs.eshopObserver.validate()
      // Id not valid (false), inform the user
      if (!valid) {
        this.$vs.notify({
          color: 'danger',
          title: 'Λάθος στον έλέγχο πεδίων',
          position: 'top-right',
          text: 'Παρακαλώ συμπληρώστε όλα τα πεδία με * και τουλάχιστον 1 διεύθυνση για έλεγχο.',
        })
      }
      // Proceed to add or update eshop.
      else {
        // item.id exists update eshop
        if (this.item.id) {
          this.$store.dispatch('updateShop', this.item).then((response) => {
            if (response.message === 'Successfully Updated') {
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })

              this.$router.replace({ name: 'eshops' })
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
            }
          })
        }
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.$store.dispatch('fetchShop', this.$route.params.id).then(() => {

      })
    } else {
      const eshop = {
        name: '',
        live_status: false,
        url: '',
        is_crawled: false,
        checked: false,
      }
      this.$store.dispatch('setShop', eshop)
    }
  },
}
</script>

<style scoped>
</style>
